import * as React from 'react'

export interface IBrandingConfig {
    appName: string
    logoFile: string
    primaryColor: string
    gatewayUrl: string
    eulaFile: string
    hideCustomerColumns?: boolean
}

const defaults: IBrandingConfig = {
    appName: 'Centreblock',
    logoFile: 'images/centreblock-logo-1x.png',
    primaryColor: '#37325B',
    gatewayUrl: '',
    eulaFile: 'eula/centreblock-eula.pdf',
}

export const BrandingContext = React.createContext<IBrandingConfig>(defaults)

interface IBrandingProviderState {
    config: IBrandingConfig
}

export class BrandingProvider extends React.Component<{}, IBrandingProviderState> {
    state: IBrandingProviderState = { config: defaults }

    async componentDidMount() {
        try {
            const res = await fetch('/config.json')
            const data = await res.json()
            const config = { ...defaults, ...data }
            this.setState({ config })
            document.title = config.appName
        } catch {
            document.title = defaults.appName
        }
    }

    render() {
        return (
            <BrandingContext.Provider value={this.state.config}>
                {this.props.children}
            </BrandingContext.Provider>
        )
    }
}
